(function () {
    'use strict';

    class OperatorService {
        constructor($q, $http, mnWebSocket, $mdDialog) {
            this.q = $q;
            this.http = $http;
            this.ws = mnWebSocket;
            this.dialog = $mdDialog;
        }

        static get $inject() {
            return ["$q", "$http", "mnWebSocket", "$mdDialog"];
        }

        getOperators() {
            const deferred = this.q.defer();
            const url = "/api/operator/";

            this.http.get(url)
                .then(success, deferred.reject);

            function success(response) {
                deferred.resolve(response.data);
            }

            return deferred.promise;
        }

        saveOperator(p) {
            let deferred = this.q.defer();
            let url = "/api/operator/";

            if (!_.isNil(p.id)) url += p.id + "/";
            this.http.post(url, p)
                .then(success, deferred.reject);

            function success(response) {
                deferred.resolve(response.data);
            }

            return deferred.promise
        }

        deleteOperator(pk) {
            let deferred = this.q.defer();
            let url = `/api/operator/${pk}/`;

            this.http.delete(url)
                .then(success, deferred.reject);

            function success(response) {
                deferred.resolve(response.data);
            }

            return deferred.promise
        }
    }

    module.exports = OperatorService;

})();
